import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomIdDirective } from './custom-id.directive';
import { MatAutocompleteInfiniteScrollDirective } from './mat-autocomplete-infinite-scroll.directive';
import { ConcreteBaseScrollingComponent } from '../_shared-components/base-scrolling-component/concrete-base-scrolling-component';

@NgModule({
  declarations: [
    CustomIdDirective,
    MatAutocompleteInfiniteScrollDirective
  ],
  imports: [
    CommonModule
  ],
  exports:[
    CustomIdDirective,
    MatAutocompleteInfiniteScrollDirective
  ],
  providers:[ConcreteBaseScrollingComponent]
})
export class DirectivesModule { }
